const TICKER_ITEMS = [
  "Made from your words.",
  "isiZulu · isiXhosa · English · Sesotho",
  "Playing across Mzansi.",
  "Love on air, always.",
  "Ngiyakuthanda — on repeat.",
  "Every record, a real story.",
  "Your love, now spinning.",
  "Siyabathanda — we love them.",
];

export default function OnAirTicker() {
  const items = [...TICKER_ITEMS, ...TICKER_ITEMS];
  return (
    <div className="bg-secondary border-b border-border overflow-hidden py-1.5">
      <div className="flex ticker-track whitespace-nowrap">
        {items.map((item, i) => (
          <span key={i} className="text-muted-foreground text-[9px] font-sans uppercase tracking-[0.2em] px-7 flex items-center gap-5">
            {item}
            <span className="w-0.5 h-0.5 rounded-full bg-muted-foreground/20 inline-block" />
          </span>
        ))}
      </div>
    </div>
  );
}
